import {BroadcastLayout, BroadcastType} from '../common/Broadcast';
import ErrorBoundary from '../directory/category/ErrorBoundary';
import withHiddenStreamer from './withHiddenStreamer';
import {BROADCAST_ITEM_DISPLAY_TYPE} from '@/constants';
const LiveBroadcastItem = ({
  thumbnailUrl,
  userId,
  userNickname,
  viewCount,
  liveType,
  title,
  categoryTags,
  autoHashTags,
  hashTags,
  allowsAdult,
  listDataType,
  score,
  hasPassword,
  hasDrops,
  startDateTime,
  broadcastId,
  handleMenuClicked,
  location,
  broadcastType,
  contextMenu,
  rankIndex,
  log,
  canResend,
  handleAfterLogSend,
  subscriptionOnly,
  categoryName,
  categoryNo,
}) => {
  return (
    <ErrorBoundary fallback={<div>로딩중</div>}>
      <BroadcastLayout
        broadcastType={broadcastType}
        viewType={BROADCAST_ITEM_DISPLAY_TYPE.GRID_VIEW}
        thumbnailUrl={thumbnailUrl}
        userId={userId}
        userNickname={userNickname}
        viewCount={viewCount}
        liveType={liveType}
        broadcastId={broadcastId}
        title={title}
        categoryName={categoryName}
        categoryNo={categoryNo}
        autoHashTags={autoHashTags}
        categoryTags={categoryTags}
        hashTags={hashTags}
        allowsAdult={allowsAdult}
        listDataType={listDataType}
        score={score}
        hasPassword={hasPassword}
        hasDrops={hasDrops}
        startDateTime={startDateTime}
        location={location}
        contextMenu={contextMenu}
        canResend={canResend}
        rankIndex={rankIndex}
        subscriptionOnly={subscriptionOnly}
        log={log}
        handleMenuClicked={handleMenuClicked}
        handleAfterLogSend={handleAfterLogSend}>
        <BroadcastType.Live />
      </BroadcastLayout>
    </ErrorBoundary>
  );
};

export default withHiddenStreamer(LiveBroadcastItem);
